import * as React from 'react';
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
    menuElement: {
        width: "200px",
        border: "1px solid "+ theme.palette.background.paper,
        height: "150px",
        margin: "5px",
        display: "inline-grid",
        borderRadius: "5px",
        alignContent: "center",
        alignItems: "center",
        justifyItems: "center",
        cursor: "pointer"
    },
    container: {
        display: "inline-flex",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    icon: {
        paddingBottom: 25
    },
    iconCircle: {
        background: theme.palette.background.paper,
        padding: "19px 18px 12px",
        borderRadius: "50%",
        "& svg": {
            fontSize: "2.5rem"
        }
    }
}));

function AdminDashboard(props) {
    const classes = useStyles();

    const handleOpenTab = (item) => {
        if(props.openTab) {
            props.openTab(item)
        }
    }

    const createMenuElement = (item) => {
        return (
            <div key={item.label+"_dash"} className={classes.menuElement} onClick={(e)=>handleOpenTab(item)}>
                <div className={classes.icon}>
                    <div className={classes.iconCircle}>{React.cloneElement(item.icon)}</div>
                </div>
                <div>{ item.label }</div>
            </div>
        )
    }

    return (<div className={classes.container}>
        {props.menu().map((item)=>(createMenuElement(item)))}
    </div>)
}

export default AdminDashboard;